import searchSlice from "../slices/searchSlice";

export const searchReducers = {
  search: searchSlice,
};
